import { Button, Flex } from '@taxbit-private/cosmic'
import { FormProvider } from 'react-hook-form'

import { useOrg } from 'contexts/OrgContext'
import { useOrgsByParent } from 'hooks/data/orgsHook'

import EntitySelectorDropdown from './EntitySelectorDropdown'
import { ALL_ENTITIES_VALUE, useOrgLegalEntities } from './hooks/useOrgLegalEntities'
import useOrgManagerFormMethods, { OrgManagerFormValues } from './hooks/useOrgManagerFormMethods'
import OrgSelectorDropdown from './OrgSelectorDropdown'

enum AccountingFormNestedViewTrackingId {
  SubmitButton = 'submit-form-button',
}

const AccountMenuNestedView = () => {
  const formMethods = useOrgManagerFormMethods()
  const { setOrg } = useOrg()
  const selectedOrgId = formMethods.watch('orgId')
  const { data: orgs, isLoading: isOrgsLoading } = useOrgsByParent()
  const { entities, isLoading: isEntitiesLoading, hasEntities } = useOrgLegalEntities(selectedOrgId)

  const resetLegalEntity = (orgId: string) => {
    // If the selected org has entities, set to "All", otherwise undefined
    formMethods.setValue('legalEntityId', hasEntities(orgId) ? ALL_ENTITIES_VALUE : undefined)
  }

  return (
    <FormProvider {...formMethods}>
      <Flex
        as="form"
        padding="m"
        growItems={true}
        onSubmit={(event: React.FormEvent) => {
          void formMethods.handleSubmit((values: OrgManagerFormValues) => {
            // If "all" is selected or no legal entity is selected, switch to the parent org
            if (!values.legalEntityId || values.legalEntityId === ALL_ENTITIES_VALUE) {
              setOrg(values.orgId)
            } else {
              // Otherwise switch to the specific legal entity
              setOrg(values.legalEntityId)
            }
          })(event)
        }}
      >
        <Flex direction="column" gap="m">
          <OrgSelectorDropdown
            onOrgChange={resetLegalEntity}
            orgs={orgs}
            isLoading={isOrgsLoading || isEntitiesLoading}
          />
          <EntitySelectorDropdown
            selectedOrgId={selectedOrgId}
            entities={entities}
            isLoading={isEntitiesLoading || isOrgsLoading}
          />
          <Button
            iconName="shuffle"
            label="Switch"
            trackingId={AccountingFormNestedViewTrackingId.SubmitButton}
            type="submit"
          />
        </Flex>
      </Flex>
    </FormProvider>
  )
}

export default AccountMenuNestedView
